/* eslint-disable react-refresh/only-export-components */
import { memo } from "react";
import { Pagination, Select } from "antd";
import { cn } from "sipli-fleet-core/utils/cn";

const PAGE_SIZE_OPTIONS = [
  { label: "10", value: "10" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
];

export interface CustomSharedPaginationProps {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  setPageSize: (pageSize: number | string) => void;
  showRowsPerPage?: boolean;
  classNames?: {
    container?: string;
  };
}

const CustomSharedPagination = ({
  totalCount,
  pageSize,
  currentPage,
  setCurrentPage,
  setPageSize,
  showRowsPerPage = true,
  classNames = {
    container: "",
  },
}: CustomSharedPaginationProps) => {
  const normalizedCurrentPage = Number.isFinite(Number(currentPage))
    ? Number(currentPage)
    : 0;
  const displayPage = Math.max(normalizedCurrentPage, 0) + 1;

  return (
    <div
      className={cn(
        "flex justify-end gap-[24px] items-center m-3 mr-6 custom_pagination_container",
        classNames.container,
      )}
    >
      {showRowsPerPage && (
        <div>
          <span className="pe-2 custom_pagination_rows_per_page">
            Rows per page:
          </span>
          <Select
            defaultValue={String(pageSize)}
            onChange={(val) => {
              setPageSize(val);
            }}
            style={{ width: 70 }}
            options={PAGE_SIZE_OPTIONS}
          />
        </div>
      )}
      <div>
        <Pagination
          simple
          responsive
          total={totalCount}
          hideOnSinglePage={false}
          pageSize={pageSize}
          current={displayPage}
          onChange={(page) => setCurrentPage(page - 1)}
          onShowSizeChange={(_, size) => setPageSize(size)}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default memo(CustomSharedPagination);
